<template>
    <div class="container">
        <div style="margin: 45px 0 20px;  color: rgb(30, 139, 195);font-weight: 500;font-size: 32px;">
            <span>История проверок</span>
        </div>
        <adminFilters v-if="admin" adminType="check_fl" :onFilterCallback="getHistory" @admin-request="adminRequest" @history-refresh="historyRefresh"/>
        <pagination v-if="pagination && history.length" :pagination="pagination" :onTurnPageCallBack="getHistory" :showRowsPerPageSelection="false" :rows_on_page="history.length"/>
        <table class="history__table">
            <thead>
                <tr>
                    <th>Дата и время</th>
                    <th v-if="admin">Пользователь</th>
                    <th>Результат проверки</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(e,i) in history" :key="i">
                    <td>{{e.date ? e.date : ''}}</td>
                    <td v-if="admin">{{e.user_name}}<br>({{e.user_login}})</td>
                    <td v-else>{{e.user_name}}<br>({{e.user_login}})</td>
                    <td>
                        <span v-if="e.code === 0">
                            <i v-if="e.status === 1" class='uk-icon-check' style='cursor: help' title='Данные найдены'></i>
                            <i v-else-if="e.status < 0" class='uk-icon-close' style='cursor: help' title='Ошибка'></i>
                            <i v-else-if="e.status === 2" class='uk-icon-minus-circle' style='cursor: help' title='Данные не найдены'></i>
                        </span>
                        <span v-else>
                            <i class='uk-icon-close' style='cursor: help' title='Ошибка'></i>
                        </span>
                        <span v-if="e.code === 0 && e.response && e.request_params && e.status === 1" class="blue-red-hover-text" @click="getFlFromHistory(e.request_params, e)">
                            <span>{{e.name ? e.name : ''}} {{e.inn ? e.inn : ''}} {{e.birthday ? e.birthday : ''}}</span>     
                        </span>
                        <span v-else>
                            <span>{{e.name ? e.name : ''}} {{e.inn ? e.inn : ''}} {{e.birthday ? e.birthday : ''}}</span>  
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
        <pagination v-if="pagination && history.length" :pagination="pagination" :onTurnPageCallBack="getHistory" :showRowsPerPageSelection="false" :rows_on_page="history.length"/>
    </div>
</template>

<script>
import axios from 'axios'
import pagination from '@/components/ui/pagination.vue'
import adminFilters from '@/components/ui/adminFilters.vue'

export default {
    components: {
        pagination,
        adminFilters
    },
    data() {
        return {
            history: [],
            pagination: null,
            show_adm: true,
            searchQuery: '',
            users: [],
            date_from: '',
            date_to: ''
        }
    },
    mounted() {
        this.getHistory()
    },
    computed: {
        admin() { return this.$store.state.user?.groups?.filter(e => e.rules.adm_check_fl)?.length },
    },
    methods: {
        adminRequest(value){
            this.show_adm = value
        },
        getFlFromHistory(request_params, fl_response) {
            if(fl_response?.response?.id_fl) {
                this.$parent.list = fl_response.response
                this.$parent.dateCheck = fl_response.date.slice(0, 10) ?? Date.now()
                this.$parent.loading = true
                this.$parent.upload = true
                
                                
                if(request_params.inn) {
                    this.$parent.formRadio = 'innForm'
                    this.$parent.inn = request_params.inn ? request_params.inn : ''
                } else {
                    this.$parent.formRadio = 'nameForm'
                    this.$parent.name = request_params.name ? request_params.name : ''
                    this.$parent.surname = request_params.surname ? request_params.surname : ''
                    this.$parent.patronymic = request_params.patronymic ? request_params.patronymic : ''
                    this.$parent.birthday = request_params.birthday ? request_params.birthday : ''
                    this.$parent.inn = request_params.inn ? request_params.inn : ''
                }
                
            }
        },
        getHistory(
            offset = 0,
            limit = 50,
            searchQuery = this.searchQuery,
            users = this.users.length ? this.users : [],
            date_from = this.date_from,
            date_to = this.date_to,
            show_adm =  this.show_adm
        ) {
            this.users = users
            axios({
                baseURL: process.env.API_FL,
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                data: {
                    method: 'id_fl',
                    data: {
                        action: "getHistory",
                        // filters: {
                        offset,
                        limit,
                        filterUsers: users,
                        search: searchQuery,
                        dateFrom: date_from,
                        dateTo: date_to,
                        show_adm
                        // }
                    },
                    auth: {
                        sid: window.apiSession
                    }
                }
            }).then(e => {
                if(e.data.code === 0) {
                    this.history = e?.data?.data?.history ?? []
                    this.pagination = e?.data?.data?.pagination
                    this.users = users
                } else {
                    this.$store.dispatch('showErrorMessage', {})
                }

            })
        },
        historyRefresh() {
            this.history.searchQuery = ''
            this.history.users = ''
            this.history.date_from = ''
            this.history.date_to = ''
            this.getHistory()
        }
    }

}
</script>

<style lang="sass" scoped>
@import "styles/global-variables.sass"

.history
    &__header
        margin-top: 25px
        font-size: 24px
        font-weight: 600
    &__table
        width: 100%
        text-align: left
        font-size: 14px
        th
            font-weight: 600
            padding: 10px 0
        td
            padding: 5px 0
.uk-icon-
    &check
        color: green
    &close
        color: red
    &minus-circle
        color: orange   
    
</style>